import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=8d4647da&"
import script from "./notification.vue?vue&type=script&lang=js&"
export * from "./notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d4647da')) {
      api.createRecord('8d4647da', component.options)
    } else {
      api.reload('8d4647da', component.options)
    }
    module.hot.accept("./notification.vue?vue&type=template&id=8d4647da&", function () {
      api.rerender('8d4647da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/notifications/notification.vue"
export default component.exports